export const AdminBranchesDashboards = {
  AdminBranchesDashboards: {
    permissionsId: 'b80495c5-45f2-4b4d-2456-08dac1673f1e',
  permissionsName: 'Branches',
  componentsId: null,
  components: null
  },
};
